import axios from 'axios';
import ApiGet from '../sections/mainheader/apiget';

class UserNameService {
    constructor(apiUrl) {
        this.GetApiUrl = apiUrl;
        this.GetUserName = (payload) => (axios.get(`${this.GetApiUrl}user/GetUserName`, payload));
        this.GetUserProfile = () => (axios.get(`${this.GetApiUrl}user/getuserProfile`));
    }
}
export default ApiGet().then((apiUrl) => new UserNameService(apiUrl));
